(ns kyber.kyber-db.activity-resource)

(defn ->ident-key
  [{activity-uuid :activity/uuid
    resource-uuid :resource/uuid}]
  (str "activity-" activity-uuid "_resource-" resource-uuid))
